import { render, staticRenderFns } from "./OrderTypePieChart.vue?vue&type=template&id=c38ccc7c&"
import script from "./OrderTypePieChart.vue?vue&type=script&lang=js&"
export * from "./OrderTypePieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports